import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'loader-spiner',
  templateUrl: './loader-spiner.component.html',
  styleUrls: ['./loader-spiner.component.scss']
})
export class LoaderSpinerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
